import React from 'react';

const SAFETY_COLORS = {
  verified: 'bg-success',
  action_selected: 'bg-danger',
  no_response: 'bg-secondary',
  unknown: 'bg-warning text-dark',
};

const SAFETY_LABELS = {
  verified: 'Verified',
  action_selected: 'Action Selected',
  no_response: 'No Response',
  unknown: 'Unknown',
};

const CALL_STATUS_COLORS = {
  initiated: 'bg-info',
  dialing: 'bg-primary',
  ringing: 'bg-primary',
  answered: 'bg-success',
  language_menu_played: 'bg-info',
  kyc_pending_played: 'bg-info',
  confirmation_played: 'bg-info',
  validation_played: 'bg-info',
  due_message_played: 'bg-info',
  action_menu_played: 'bg-info',
  dtmf_received: 'bg-warning text-dark',
  action_recorded: 'bg-danger',
  completed: 'bg-secondary',
  failed: 'bg-danger',
  disconnected: 'bg-dark',
  no_answer: 'bg-secondary',
  unable_to_connect: 'bg-dark',
  retrying: 'bg-warning text-dark',
  busy: 'bg-warning text-dark',
};

export function SafetyBadge({ status }) {
  return (
    <span className={`badge call-status-badge ${SAFETY_COLORS[status] || 'bg-secondary'}`}>
      {SAFETY_LABELS[status] || status}
    </span>
  );
}

export function CallStatusBadge({ status }) {
  return (
    <span className={`badge call-status-badge ${CALL_STATUS_COLORS[status] || 'bg-secondary'}`}>
      {(status || '').replace(/_/g, ' ')}
    </span>
  );
}
